const DEFECT_KEYS = {
  sneakers: ['missing_accessories', 'display_item', 'yellowing', 'sneakers_defect'],
  apparels: ['no_tags', 'missing_original', 'manufacture_defect'],
  lifestyles: ['no_tags', 'missing_original', 'manufacture_defect'],
  handbags: ['missing_accessories', 'discoloration', 'scratches', 'transferred_color', 'sign_of_wear'],
};
const ACCESSORY_KEYS = ['no_tags', 'no_extra_laces', 'no_wrap_paper'];
const INCLUSION_KEYS = ['box', 'dust_bag', 'tag', 'mirror', 'straps', 'authentication_card'];
const ALL_DEFECT_KEYS = [...new Set(Object.values(DEFECT_KEYS).reduce((keys, categoryKeys) => keys.concat(categoryKeys), []))];
const bool = (value) => value === true || value === 1 || value === '1';
const pickFlags = (keys, source) => keys.reduce((result, key) => ({ ...result, [key]: bool(source[key]) }), {});

export const emptyQcFlags = () => ({
  defects: pickFlags(ALL_DEFECT_KEYS, {}),
  missing_accessories_list: pickFlags(ACCESSORY_KEYS, {}),
  inclusions: pickFlags(INCLUSION_KEYS, {}),
});

export const initialReturnQcForm = (sale) => {
  const source = (sale.offer && sale.offer.user_sell) || {};
  const archive = sale.sale_product || {};
  const variant = source.product_variant || {};
  const productId = archive.product_variant_id || source.product_variant_id;
  const category = String(archive.category_name || (variant.product && variant.product.category && variant.product.category.name) || '').toLowerCase();
  const rawDefects = Array.isArray(source.defects)
    ? source.defects.reduce((result, item) => ({ ...result, [String(item.name).toLowerCase()]: item.value }), {}) : {};
  const flags = { ...rawDefects, ...source.constructed_defects };
  ['missing_accessories', 'display_item', 'yellowing', 'sneakers_defect'].forEach((key) => {
    flags[key] = archive[key] != null ? archive[key] : source[key];
  });
  const size = archive.size || source.size || {};
  const name = archive.display_name || variant.display_name || '';
  const sku = archive.SKU || variant.SKU || '';
  return {
    product: productId ? {
      id: productId,
      name: [name, sku ? `(${sku})` : ''].filter(Boolean).join(' '),
      category,
      hide_box_info: variant.hide_box_info,
    } : null,
    size: (archive.size_id || source.size_id || size.id) ? { id: archive.size_id || source.size_id || size.id, US: size.US || '' } : null,
    sneakers_condition: archive.sneakers_condition || source.sneakers_condition || '',
    box_condition: archive.box_condition || source.box_condition || '',
    defects: pickFlags(ALL_DEFECT_KEYS, flags),
    missing_accessories_list: pickFlags(ACCESSORY_KEYS, { ...rawDefects, ...source.missing_accessories_list }),
    inclusions: pickFlags(INCLUSION_KEYS, { ...rawDefects, ...source.inclusions }),
  };
};

export const returnQcPayload = (form) => {
  const category = form.product.category;
  return {
    product_variant_id: form.product.id,
    size_id: form.size.id,
    sneakers_condition: form.sneakers_condition,
    box_condition: form.box_condition,
    defects: pickFlags(DEFECT_KEYS[category] || [], form.defects),
    missing_accessories_list: pickFlags(
      category === 'sneakers' && form.defects.missing_accessories ? ACCESSORY_KEYS : [], form.missing_accessories_list
    ),
    inclusions: pickFlags(category === 'handbags' ? INCLUSION_KEYS : [], form.inclusions),
  };
};
